"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.locationLookupClient = exports.scrubString = exports.cleanSearchTerm = void 0;
const cleanSearchTerm = (searchTerm) => {
    return (searchTerm
        .match(/([a-zA-Z0-9_äöüæøåïáéíóúàâñçčćžđšžćńóśźżąęłÏÄÖÜÆØÅÁÉÍÓÚÀÂÑÇČĆŽĐŠŽĆŃÓŚŹŻĄĘŁß.']|\s|-+)*/g)
        ?.join('')
        .replace(/( )+/g, ' ') || '');
};
exports.cleanSearchTerm = cleanSearchTerm;
const scrubString = (input) => input.replace(new RegExp('&rsquo;', 'g'), "'");
exports.scrubString = scrubString;
const toLocation = (location) => {
    const name = (0, exports.scrubString)(location.name);
    if (!location.property) {
        return { ...location, name };
    }
    const [title, ...locationParts] = (0, exports.scrubString)(name).split(', ').slice(1);
    const id = location?.id?.replace(/\/\s*$/, "");
    const locationLink = location?.link?.replace(/\/\s*$/, "");
    const link = locationLink?.replace(/holiday-parks|lodges/, "accom");
    return {
        id,
        link,
        title: title ?? name,
        location: locationParts.join(', '),
        property: true,
    };
};
async function locationLookupClient(input, config) {
    const { brand = 'cottages.com', language = '826', accommodationType = null, maxAutocompleteResults = null, auth: { LOCATION_API_URL, LOCATION_API_KEY }, } = config;
    const params = new URLSearchParams({
        term: input && (0, exports.cleanSearchTerm)(input),
        ...(accommodationType && {
            accommodationType,
        }),
        ...(maxAutocompleteResults && {
            maxAutocompleteResults: maxAutocompleteResults.toString(),
        }),
    });
    const url = `${LOCATION_API_URL}/${brand}/${language}?${params.toString()}`;
    try {
        const response = await fetch(url, {
            headers: {
                'Content-Type': 'application/json',
                'X-API-KEY': LOCATION_API_KEY,
            },
        });
        if (!response.ok) {
            return [];
        }
        const locations = (await response.json());
        return locations.map((location) => toLocation(location));
    }
    catch (_) {
        return [];
    }
}
exports.locationLookupClient = locationLookupClient;
//# sourceMappingURL=location-lookup-client.js.map